export const DIVISIONS = [
  "Presence & Listings",
  "Social Media Management",
  "Production",
  "Website & Digital Build",
  "General / Internal",
];

export const STATUSES = [
  "Not Started",
  "In Progress",
  "Waiting for Client",
  "Shoot Planned",
  "Review",
  "Client Review",
  "Revision",
  "Completed",
];

export const PRIORITIES = ["Low", "Medium", "High", "Urgent"];

export const PLATFORMS = [
  "Google Business", "Instagram", "Facebook", "Amazon", "Flipkart",
  "Meesho", "IndiaMART", "Other",
];

export const WORK_TYPES = [
  "Profile Creation", "Verification", "Seller Registration",
  "Product Listing", "Service Listing", "Optimization", "Content",
];

export const APPROVAL_STATES = [
  "Not Required Yet", "Not Sent", "Sent", "Approved", "Revision Requested",
];

export const ROLES = [
  { value: "owner", label: "Owner" },
  { value: "account_manager", label: "Account Manager" },
  { value: "social_media_manager", label: "Social Media Manager" },
  { value: "listing_executive", label: "Listing Executive" },
  { value: "production_manager", label: "Production Manager" },
  { value: "developer", label: "Developer" },
];

export function roleLabel(value) {
  const r = ROLES.find((x) => x.value === value);
  return r ? r.label : value;
}

export function formatINR(n) {
  const num = Number(n || 0);
  return "₹" + num.toLocaleString("en-IN");
}

export function statusClasses(status) {
  const s = (status || "").toLowerCase();
  if (s.includes("complete")) return "bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66]";
  if (s.includes("progress")) return "bg-[#007AFF]/10 border-[#007AFF]/30 text-[#4DA3FF]";
  if (s.includes("review")) return "bg-[#FFD600]/10 border-[#FFD600]/30 text-[#FFD600]";
  if (s.includes("waiting") || s.includes("revision")) return "bg-[#FF9500]/10 border-[#FF9500]/30 text-[#FF9500]";
  if (s.includes("shoot")) return "bg-[#AF52DE]/10 border-[#AF52DE]/30 text-[#C77DFF]";
  return "bg-white/5 border-white/15 text-zinc-400";
}

export function priorityClasses(priority) {
  const p = (priority || "").toLowerCase();
  if (p === "urgent") return "bg-[#FF3B30]/10 border-[#FF3B30]/30 text-[#FF6259]";
  if (p === "high") return "bg-[#FF9500]/10 border-[#FF9500]/30 text-[#FF9500]";
  if (p === "medium") return "bg-[#007AFF]/10 border-[#007AFF]/30 text-[#4DA3FF]";
  return "bg-white/5 border-white/15 text-zinc-400";
}

export function approvalClasses(a) {
  const s = (a || "").toLowerCase();
  if (s === "approved") return "bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66]";
  if (s === "sent") return "bg-[#FFD600]/10 border-[#FFD600]/30 text-[#FFD600]";
  if (s.includes("revision")) return "bg-[#FF3B30]/10 border-[#FF3B30]/30 text-[#FF6259]";
  return "bg-white/5 border-white/15 text-zinc-500";
}

export const DIVISION_PIPELINES = {
  "Presence & Listings": ["Collect Docs", "Create Account", "Verify", "Prepare Listing", "Client Approve", "Publish", "Handover"],
  "Production": ["Brief", "Concept", "Quote", "Schedule", "Shoot", "Edit", "Deliver"],
  "Website & Digital Build": ["Requirement", "Sitemap", "UI/UX", "Development", "QA", "Client Review", "Launch"],
  "Social Media Management": ["Plan", "Create", "Schedule", "Publish", "Report"],
};

export const AGENCY_WORKFLOW = ["Lead", "Onboard", "Plan", "Assign", "Execute", "Approve", "Deliver"];

export const SHIPMENT_STATUSES = [
  "Pending Pickup", "Picked Up", "In Transit", "Out for Delivery",
  "Delivered", "Returned / RTO", "Cancelled",
];

export const COURIERS = [
  "Delhivery", "Blue Dart", "DTDC", "India Post", "Shiprocket",
  "Ecom Express", "XpressBees", "Other",
];

export function shipmentClasses(status) {
  const s = (status || "").toLowerCase();
  if (s.includes("delivered")) return "bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66]";
  if (s.includes("out for")) return "bg-[#FFD600]/10 border-[#FFD600]/30 text-[#FFD600]";
  if (s.includes("transit")) return "bg-[#007AFF]/10 border-[#007AFF]/30 text-[#4DA3FF]";
  if (s.includes("picked")) return "bg-[#AF52DE]/10 border-[#AF52DE]/30 text-[#C77DFF]";
  if (s.includes("return") || s.includes("cancel")) return "bg-[#FF3B30]/10 border-[#FF3B30]/30 text-[#FF6259]";
  return "bg-white/5 border-white/15 text-zinc-400";
}
